/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { VatExemptionReductionService } from "services/vat-exemption-reduction";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    const docDateObj =
      item.items && item.items[0] && item.items[0].documentDate
        ? new Date(item.items[0].documentDate)
        : null;
    const docDate = docDateObj ? docDateObj.toLocaleDateString("vi-VN") : "";

    return {
      id: item._id,
      documentNumber: item.documentNumber || item.code || "",
      docDate,
      company: item.company?.name || "N/A",
      exemptedAmount:
        item.items?.reduce((sum, it) => sum + (parseFloat(it.exemptedAmount) || 0), 0) || 0,
      alreadyExemptedAmount: formatCurrency.format(
        item.items?.reduce((sum, it) => sum + (parseFloat(it.alreadyExemptedAmount) || 0), 0) || 0
      ),
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    {
      Header: "Số chứng từ",
      accessor: "documentNumber",
    },
    {
      Header: "Ngày chứng từ",
      accessor: "docDate",
    },
    {
      Header: "Đơn vị",
      accessor: "company",
      width: "20%",
    },
    {
      Header: "Tổng GTGT được miễn giảm",
      accessor: "exemptedAmount",
      width: "15%",
    },
    {
      Header: "Tổng GTGT đã miễn giảm",
      accessor: "alreadyExemptedAmount",
      width: "15%",
    },
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
    },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function DetailLedgerVatExemptionReduction() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await VatExemptionReductionService.paginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ Chi Tiết GTGT Miễn Giảm:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default DetailLedgerVatExemptionReduction;
